module.exports = __webpack_public_path__ + "img/step2.f20f9b62.png";